import React from "react";
import SupportPageTitle from "../Components/SupportPageTitle";
import SupportPageLayout from "../Components/SupportPageLayout";
import CollapseFaq from "../Components/CollapseFaq";
import { Link } from "react-router-dom";
import TermsAndConditions from "../Components/TermsAndConditions";

const Legal = () => {
  return (
    <SupportPageLayout>
      <SupportPageTitle text="Legal Terms" />
      <CollapseFaq title="Cancellation Policy">
        <div className="p-3">
          <h4 className="fs-5 mb-3">For Experiencers:</h4>
          <p>
            At Wareeg, we understand that unexpected circumstances can arise,
            and sometimes cancellations are necessary. To ensure a fair and
            consistent policy for all parties, we have established the following
            guidelines:
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Cancellation:
          </h4>
          <ul>
            <li>
              <p>
                <span className="fw-semibold">Pending reservation: </span>If the
                local has not accepted or declined the experience requested by
                the experiencer, the payment charges will be refunded and the
                funds will be returned.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold">
                  Confirmed reservation or no-show:{" "}
                </span>{" "}
                If a confirmed reservation is cancelled 24 hours before the
                start time, the Experiencer will receive a refund minus fees.
                However, there will be no refund for cancellations within 24
                hours or no-shows.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold">Local cancels or no-show: </span>
                Experiencer gets full refund minus fees.
              </p>
            </li>
          </ul>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Booking Requests:
          </h4>
          <p>
            To ensure timely processing, the local should either accept or
            decline the request within 48 hours or for same day bookings, before
            experience start time, otherwise it will expire. If declined or
            expired, there will be no charge to the Experiencer and the local
            will not receive payouts.
          </p>
          <h4 className="fs-5 mb-3">For Locals:</h4>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Payout:
          </h4>
          <ul>
            <li>
              <p>
                <span className="fw-semibold">Pending booking: </span>Local
                didn't accept or decline yet, no payout for them.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold">
                  Confirmed booking or no-show:{" "}
                </span>
                Experiencer gets full refund if cancelled 24 hours before start
                time, no refund for cancellations within 24 hours or no-shows.
                Local gets full payout if cancelled within 24 hours or no-show.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold">Local cancels or no-show: </span>
                Experiencer gets full refund, local gets no payout.
              </p>
            </li>
          </ul>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Booking Requests:
          </h4>
          <p>
            Local must accept or decline within 48 hours, else it expires. If
            declined or expired, Experiencer won't be charged and local won't
            receive payouts.
          </p>
          <p>
            If either party is prevented from performing its obligations under
            the Terms and Conditions due to circumstances beyond its reasonable
            control, such as acts of God, natural disasters, war, terrorism,
            riots, embargoes, acts of civil or military authorities, fire,
            floods, accidents, pandemics, epidemics or disease, strikes,
            shortages of transportation facilities, fuel, energy, labor, or
            materials, Wareeg shall not be liable for any resulting delay or
            failure. In such a situation, the affected party will promptly
            inform the other party and use reasonable commercial efforts to
            resume performance as soon as it is reasonably practicable.
          </p>
          <p>
            Wareeg reserves the right to make changes to this Cancellation
            Policy at any time and for any reason, with or without notice. By
            using Wareeg you agree to this cancellation policy and any changes
            made in the future.
          </p>
        </div>
      </CollapseFaq>
      <CollapseFaq title="Cancellation Policy for Locals">
        <div className="p-3">
          <h4 className="fs-5 mb-3">For Locals:</h4>
          <p>
            At Wareeg, we understand that unexpected circumstances can arise,
            and sometimes cancellations are necessary. To ensure a fair and
            consistent policy for all parties, we have established the following
            guidelines:
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Payout:
          </h4>
          <ul>
            <li>
              <p>
                <span className="fw-semibold">Pending booking: </span>Local
                didn't accept or decline yet, no payout for them.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold">
                  Confirmed booking or no-show:{" "}
                </span>{" "}
                Experiencer gets full refund if cancelled 24 hours before start
                time, no refund for cancellations within 24 hours or no-shows.
                Local gets full payout if cancelled within 24 hours or no-show.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold">Local cancels or no-show: </span>
                Experiencer gets full refund, local gets no payout.
              </p>
            </li>
          </ul>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Booking Requests:
          </h4>
          <p>
            Local must accept or decline within 48 hours, else it expires. If
            declined or expired, Experiencer won't be charged and local won't
            receive payouts.
          </p>
          <p>
            If either party is prevented from performing its obligations under
            the Terms and Conditions due to circumstances beyond its reasonable
            control, such as acts of God, natural disasters, war, terrorism,
            riots, embargoes, acts of civil or military authorities, fire,
            floods, accidents, pandemics, epidemics or disease, strikes,
            shortages of transportation facilities, fuel, energy, labor, or
            materials, Wareeg shall not be liable for any resulting delay or
            failure. In such a situation, the affected party will promptly
            inform the other party and use reasonable commercial efforts to
            resume performance as soon as it is reasonably practicable.
          </p>
          <p>
            Wareeg reserves the right to make changes to this Cancellation
            Policy at any time and for any reason, with or without notice. By
            using Wareeg you agree to this cancellation policy and any changes
            made in the future
          </p>
          <h4 className="fs-5 mb-3">For Locals:</h4>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Payout:
          </h4>
          <ul>
            <li>
              <p>
                <span className="fw-semibold">Pending booking: </span>Local
                didn't accept or decline yet, no payout for them.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold">
                  Confirmed booking or no-show:{" "}
                </span>
                Experiencer gets full refund if cancelled 24 hours before start
                time, no refund for cancellations within 24 hours or no-shows.
                Local gets full payout if cancelled within 24 hours or no-show.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold">Local cancels or no-show: </span>
                Experiencer gets full refund, local gets no payout.
              </p>
            </li>
          </ul>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Booking Requests:
          </h4>
          <p>
            Local must accept or decline within 48 hours, else it expires. If
            declined or expired, Experiencer won't be charged and local won't
            receive payouts.
          </p>
          <p>
            If either party is prevented from performing its obligations under
            the Terms and Conditions due to circumstances beyond its reasonable
            control, such as acts of God, natural disasters, war, terrorism,
            riots, embargoes, acts of civil or military authorities, fire,
            floods, accidents, pandemics, epidemics or disease, strikes,
            shortages of transportation facilities, fuel, energy, labor, or
            materials, Wareeg shall not be liable for any resulting delay or
            failure. In such a situation, the affected party will promptly
            inform the other party and use reasonable commercial efforts to
            resume performance as soon as it is reasonably practicable.
          </p>
          <p>
            Wareeg reserves the right to make changes to this Cancellation
            Policy at any time and for any reason, with or without notice. By
            using Wareeg you agree to this cancellation policy and any changes
            made in the future.
          </p>
        </div>
      </CollapseFaq>
      <CollapseFaq title="Copyright Policy">
        <div className="p-3">
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Coming Soon!
          </h4>
        </div>
      </CollapseFaq>
      <CollapseFaq title="Delete Account">
        <div className="p-3">
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Account Deletion Policy
          </h4>
          <p>
            This Account Deletion Policy outlines how Wareeg ("we", "us", or
            "our") handles the deletion of user accounts on our peer-to-peer
            marketplace platform ("Platform"). We are committed to respecting
            your privacy and complying with applicable data protection laws,
            including the General Data Protection Regulation ("GDPR") and the
            California Consumer Privacy Act ("CCPA").
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Deleting Your Account
          </h4>
          <p>
            To delete your account, please follow these steps:
            <ol>
              <li>
                <p>Log into the Wareeg app.</p>
              </li>
              <li>
                <p>Navigate to your account settings.</p>
              </li>
              <li>
                <p>Select the option to "Delete Account".</p>
              </li>
              <li>
                <p>Enter your password to confirm the deletion.</p>
              </li>
              <li>
                <p>Click "Delete" to complete the process.</p>
              </li>
              <li>
                <p>Verification of Account Deletion</p>
              </li>
            </ol>
          </p>
          <p>
            Upon successful deletion:
            <ul>
              <li>
                <p>
                  You will no longer be able to log into your account using the
                  app.
                </p>
              </li>
              <li>
                <p>
                  Wareeg will not send a confirmation email regarding the
                  deletion of your account.
                </p>
              </li>
            </ul>
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Effects of Account Deletion
          </h4>
          <p>
            Once your account is deleted:
            <ul>
              <li>
                <p>
                  Your profile and all associated personal information will be
                  permanently removed from our Platform.
                </p>
              </li>
              <li>
                <p>
                  We will no longer use your personal information for any
                  purposes outlined in our Privacy Policy, except as necessary
                  to comply with legal obligations or resolve disputes.
                </p>
              </li>
              <li>
                <p>
                  We may retain certain information if required by law or for
                  legitimate business purposes, such as fraud prevention or
                  enforcement of our terms and policies.
                </p>
              </li>
              <li>
                <p>Retention of Data</p>
              </li>
            </ul>
            We retain personal information for as long as necessary to provide
            our services and fulfill our legal obligations. After account
            deletion, we securely delete or anonymize your personal information
            as soon as it is no longer needed for the purposes for which it was
            collected.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Communication
          </h4>
          <p>
            Wareeg will not send a confirmation email upon account deletion. If
            you have any questions or concerns about the deletion process,
            please contact us through our{" "}
            <Link to="/contactus">Contact Us </Link>page.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Children's Privacy
          </h4>
          <p>
            Our Platform is not intended for children under the age of 18. If we
            discover that we have inadvertently collected personal information
            from a child under 18, we will take steps to delete the information
            as soon as possible.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Changes to this Policy
          </h4>
          <p>
            We may update this Account Deletion Policy from time to time to
            reflect changes in our privacy practices. We encourage you to review
            this policy periodically for any updates. We will notify you of any
            material changes through our Platform.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Contact Us
          </h4>
          <p>
            If you have any questions or concerns, please contact us through our{" "}
            <Link to="/contactus">Contact Us </Link>page.
          </p>
        </div>
      </CollapseFaq>
      <CollapseFaq title="Community Guidelines">
        <div className="p-3">
          <p>
            At Wareeg, we aim to create a community of respectful, trustworthy,
            and enjoyable experiences. In order to ensure that all users have a
            positive experience, we ask that all users abide by the following
            guidelines:
          </p>
          <ol>
            <li>
              <p>
                <span className="fw-semibold" style={{ color: "#4189dd" }}>
                  Respect Others:{" "}
                </span>
                Treat everyone you interact with on Wareeg with respect and
                kindness. Avoid any behavior that could be considered harassing,
                threatening, or discriminatory.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold" style={{ color: "#4189dd" }}>
                  Honest-Communication:{" "}
                </span>{" "}
                transparent and honest in all your communications with other
                users. If you need to cancel an experience, please do so as soon
                as possible and communicate clearly with the organizer.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold" style={{ color: "#4189dd" }}>
                  Respectful and Appropriate Content:{" "}
                </span>
                Do not post any content that is abusive, harmful, sexual,
                illicit, illegal, or otherwise inappropriate. All content should
                be respectful and in line with our community standards.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold" style={{ color: "#4189dd" }}>
                  Safety First:{" "}
                </span>
                Your safety and the safety of others is always the top priority.
                If you have any concerns about your safety during an experience,
                please reach out to Wareeg support.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold" style={{ color: "#4189dd" }}>
                  Respect Property:{" "}
                </span>
                Do not damage or destroy any property while participating in an
                experience. Be mindful of your surroundings and leave the
                location of the experience in the same condition as when you
                arrived.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold" style={{ color: "#4189dd" }}>
                  Solicitation:{" "}
                </span>
                Do not engage in any illegal activities or solicit the use of
                illegal substances, and do not offer to drive guests or hosts to
                or from an experience. Any kind of solicitation, whether before,
                during or after an experience, is not allowed on our platform.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold" style={{ color: "#4189dd" }}>
                  No Off-Platform Communication:{" "}
                </span>
                Do not make any bookings, arrangements, or communications
                between experiencer or local outside of the Wareeg platform.
                This is to ensure safety and security for all users and maintain
                the integrity of the Wareeg platform.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold" style={{ color: "#4189dd" }}>
                  Report Unacceptable Behavior:{" "}
                </span>
                If you encounter any behavior that violates these community
                guidelines or is otherwise unacceptable, please report it to
                Wareeg support.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold" style={{ color: "#4189dd" }}>
                  Follow Laws and Regulations:{" "}
                </span>
                Ensure that your actions while participating in an experience
                are in compliance with all applicable laws and regulations.
              </p>
            </li>
            <li>
              <p>
                <span className="fw-semibold" style={{ color: "#4189dd" }}>
                  Trust and Fairness:{" "}
                </span>
                Wareeg operates on a trust-based system, and we expect all users
                to act fairly and honor their commitments. If you believe that
                another user has acted in a manner that violates this principle,
                please report it to Wareeg support.
              </p>
            </li>
          </ol>
          <p>
            Wareeg reserves the right to remove any user who violates these
            community guidelines, and to take other actions as necessary to
            maintain a safe and enjoyable experience for all users.
          </p>
          <p>
            By using Wareeg, you agree to abide by these community guidelines
            and to act in accordance with the principles of trust, respect, and
            safety. Thank you for your cooperation!
          </p>
        </div>
      </CollapseFaq>
      <CollapseFaq title="Privacy Policy">
        <div className="p-3">
          <p>
            This Privacy Policy ("Policy") outlines how Wareeg ("we", "us", or
            "our") collects, uses, and protects the personal information of
            users ("Users") of our peer-to-peer marketplace platform
            ("Platform") that facilitates experiencers ("Guests") to book locals
            ("Hosts") to host a private experience anytime, anywhere. This
            Policy is in compliance with the General Data Protection Regulation
            ("GDPR") and the California Consumer Privacy Act ("CCPA").
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Information We Collect
          </h4>
          <p>
            We collect<span style={{ color: "red" }}>*</span> personal
            information when Users register an account or use the Platform,
            including:
          </p>
          <ul>
            <li>
              <p>
                Contact information: name, email address, phone number, and
                location
              </p>
            </li>
            <li>
              <p>
                Personal information: SSN, ID, DOB, residential address, and
                availability
              </p>
            </li>
            <li>
              <p>
                Payment information: payment card details or direct deposit
                information
              </p>
            </li>
            <li>
              <p>
                Profile information: profile picture, interests, languages,
                hosting city, and bio
              </p>
            </li>
            <li>
              <p>
                Communication information: any correspondence Users have with
                each other through the Platform
              </p>
            </li>
          </ul>
          <p>
            <span style={{ color: "red" }}>*</span>The information you will be
            asked to input during registration may vary depending on whether you
            are registering for a guest or host account/profile.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            How We Use Your Information
          </h4>
          <p>We use personal information for the following purposes:</p>
          <ul>
            <li>To provide and improve our Platform</li>
            <li>To verify User identity and prevent fraudulent activity</li>
            <li>
              To communicate with Users about their experiences and bookings
            </li>
            <li>To process payments, payouts and refunds</li>
            <li>
              To personalize User experience and match Users with compatible
              hosts or guests
            </li>
            <li>To comply with legal obligations, including GDPR and CCPA</li>
          </ul>
          <p>
            We will not use your personal information for marketing purposes
            without your consent.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Information Sharing
          </h4>
          <p>
            We may share personal information with the following third-party
            service providers:
          </p>
          <ul>
            <li>
              Payment processing companies to process payments and payouts
            </li>
            <li>Hosting providers to host the Platform</li>
            <li>Customer service providers to assist with user support</li>
            <li>
              Communication providers to enable communication between Users
            </li>
          </ul>
          <p>
            We may also share personal information with law enforcement or
            government agencies in response to a valid legal request.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Cookies
          </h4>
          <p>
            We use cookies and similar technologies to enhance User experience
            on our Platform. Cookies are small data files that are placed on
            your device. They may be used to store your preferences or track
            your activity on our Platform. You may opt-out of cookies by
            adjusting your browser settings.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Data Retention
          </h4>
          <p>
            We retain personal information for as long as necessary to provide
            our Platform and fulfill our legal obligations. We will securely
            delete personal information when it is no longer needed.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Security
          </h4>
          <p>
            We take appropriate measures to protect personal information against
            unauthorized access, alteration, or destruction. We restrict access
            to personal information to employees and contractors who need to
            know the information to provide our services.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Your Rights
          </h4>
          <p>
            You have the right to access, correct, or delete your personal
            information. You may also request that we restrict the processing of
            your personal information or transfer it to another party. To
            exercise these rights, please contact us using the contact
            information below.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Children's Privacy
          </h4>
          <p>
            Our Platform is not intended for use by children under the age of
            18. We do not knowingly collect personal information from children
            under 18. If you become aware that a child under 18 has provided us
            with personal information, please contact us using the contact
            information below.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Changes to this Policy
          </h4>
          <p>
            We may update this Policy from time to time to reflect changes in
            our privacy practices. We will notify Users of any material changes
            to this Policy by email or through our Platform.
          </p>
          <p>
            {/* <Link to="/"> */}
            Contact Us If you have any questions or concerns about this Policy,
            please contact us at&nbsp;
            {/* </Link> */}
            <a href="https://www.wareeg.com/" target="_blank">
              wareeg.com.
            </a>
          </p>
        </div>
      </CollapseFaq>
      <CollapseFaq title="Refund Policy">
        <div className="p-3">
          <p>
            At Wareeg, we strive to ensure that all experiences booked through
            our platform meet the expectations of our Experiencers. However, we
            understand that there may be situations where a refund is necessary.
            To ensure a fair and consistent policy for all parties, we have
            established the following guidelines:
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Refund Requests:
          </h4>
          <p>
            If an Experiencer faces cancellations or no-shows while booking an
            experience through Wareeg, they may be eligible for a refund. To
            check the status of their refund, Experiencers can submit a
            submission through wareeg.io.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Grounds for Refund:
          </h4>
          <p>
            We will consider refund requests based on the following grounds:
          </p>
          <ul>
            <li>
              <p>
                The experiencer cancels a reservation up to 24 hours before the
                start time.
              </p>
            </li>
            <li>The local did not show up for the scheduled experience.</li>
            <li>The local canceled the experience before the start time.</li>
          </ul>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Refund Amount:
          </h4>
          <p>
            If we determine that an Experiencer is entitled to a refund, we will
            issue a refund for the full amount paid minus any fees charged by
            Wareeg.
          </p>
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Refund Processing:
          </h4>
          <p>
            Refunds will be processed via the payment method used during
            booking, with processing times varying due to various factors.
          </p>
          <p>
            Wareeg reserves the right to make changes to this Refund Policy at
            any time and for any reason, with or without notice. By using
            Wareeg, you agree to this refund policy and any changes made in the
            future.
          </p>
        </div>
      </CollapseFaq>
      <CollapseFaq title="Terms and Conditions">
        <TermsAndConditions />
      </CollapseFaq>
      <CollapseFaq title="Trademark Guidelines">
        <div className="p-3">
          <h4 className="fs-5 mb-3" style={{ color: "#4189dd" }}>
            Coming Soon!
          </h4>
        </div>
      </CollapseFaq>
    </SupportPageLayout>
  );
};

export default Legal;
